import { Routes, Route, Navigate } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import { AppLayout } from '@/components/layout/AppLayout';
import { DashboardPage } from '@/pages/DashboardPage';
import { SecurityPosturePage } from '@/pages/SecurityPosturePage';
import { DataResidencyPage } from '@/pages/DataResidencyPage';
import { PrivacyAssessmentsPage } from '@/pages/PrivacyAssessmentsPage';
import { ComplianceReportsPage } from '@/pages/ComplianceReportsPage';
import { DrStatusPage } from '@/pages/DrStatusPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicyPage';
import { TermsPage } from '@/pages/TermsPage';
import { SlaPage } from '@/pages/SlaPage';
import { SupportPage } from '@/pages/SupportPage';

export default function App() {
  return (
    <Routes>
      {/* 受保护区域：需 Entra ID 登录 */}
      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="security-posture" element={<SecurityPosturePage />} />
          <Route path="data-residency" element={<DataResidencyPage />} />
          <Route path="privacy-assessments" element={<PrivacyAssessmentsPage />} />
          <Route path="compliance-reports" element={<ComplianceReportsPage />} />
          <Route path="dr-status" element={<DrStatusPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
      </Route>
      {/* 公开页面：Marketplace 要求隐私/条款可匿名访问 */}
      <Route element={<AppLayout />}>
        <Route path="legal/privacy" element={<PrivacyPolicyPage />} />
        <Route path="legal/terms" element={<TermsPage />} />
        <Route path="legal/sla" element={<SlaPage />} />
        <Route path="support" element={<SupportPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
